module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-home-reviews"
  }, [_c('Title', {
    attrs: {
      "props": _vm.props.intro
    }
  }), _c('div', {
    staticClass: "custom-home-reviews__row"
  }, [_c('Testimonial'), _c('div', {
    staticClass: "custom-home-reviews__img-col"
  }, [_c('img', {
    attrs: {
      "src": _vm.props.img
    }
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8da03da","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-home-reviews/custom-home-reviews.pug
// module id = 558
// module chunks = 1